import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const inlineSuggestionPluginKey: PluginKey = new PluginKey('aiInlineSuggestion');
